import s from '#components/common/heroMeta/HeroMeta.module.scss';
import dayjs from 'dayjs';
import {
  LivestreamDetails,
  LivestreamState,
} from '#types/generated/graphql-types';
import { LivestreamStartTimeLabelMap } from '#config';
import { formatLocalizedTimestamp } from '#utils/format-time';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  streamDetails?: LivestreamDetails;
};

const HeroMetaLivestreamInfos = ({ streamDetails }: Props) => {
  const { t } = useTranslation();

  const start = dayjs(streamDetails.startDate);
  const end = dayjs(streamDetails.endDate);
  const duration = end.diff(start);

  return (
    <>
      <li className={s.item}>
        <span className={s.itemInner}>
          {`${dayjs(streamDetails.startDate).format('DD.MM.YYYY')}`}
        </span>
      </li>

      {streamDetails.streamState !== LivestreamState.Ended &&
        streamDetails.streamState !== LivestreamState.Archived && (
          <>
            <li className={s.item}>
              <span className={s.itemInner}>
                {t(LivestreamStartTimeLabelMap[streamDetails.streamState], {
                  time: dayjs(streamDetails.startDate).format('HH:mm'),
                })}
                {duration > 0 && (
                  <>
                    {' • '}
                    {t('livestreamDurationLabel', {
                      time: formatLocalizedTimestamp(duration, t),
                    })}
                  </>
                )}
              </span>
            </li>
          </>
        )}
    </>
  );
};

export default HeroMetaLivestreamInfos;
